import React, { ReactNode, useMemo, useState } from "react";
import OrdersList from "./ordersList/OrdersList";
import OrderAdWrapper from "../dialogAd/OrderAdWrapper";
import { useAppSelector } from "../../../utils/store";
import { AppPage } from "../../../core/navigation/navigation.slice";
import { OrderDetails } from "./orderDetails/OrderDetails";
import AdTimeSelect from "./orderDetails/AdTimeSelect";
import Invoicing from "./invoicing/Invoicing";
import { AuthRequestDetail } from "./ordersList/organizationAuthState/AuthRequestDetail";
import TutorialsWrapper from "../tutorials/TutorialsWrapper";
import { StopCampaignSettings } from "../dialogAd/StopCampaignSettings";
import styles from "./AppPageWrapper.module.scss";
import FestivalFab from "./festivalFab/FestivalFab";
import Pricing from "../Pricing/Pricing";

const AppPageWrapper: React.FC<React.PropsWithChildren<unknown>> = () => {
  const currentPage = useAppSelector((state) => state.navigation.appPage);
  const getPage = useMemo(() => {
    switch (currentPage) {
      case AppPage.SubmitAd:
        return <OrderAdWrapper />;
      case AppPage.OrdersList:
        return <OrdersList />;
      case AppPage.OrderDetail:
        return <OrderDetails />;
      case AppPage.StopCampaign:
        return <StopCampaignSettings />;
      case AppPage.AdTimeSelect:
        return <AdTimeSelect />;
      case AppPage.Invoicing:
        return <Invoicing />;
      case AppPage.AuthRequestDetail:
        return <AuthRequestDetail />;
      case AppPage.Tutorial:
        return <TutorialsWrapper />;
      case AppPage.AdvertisementPrices:
        return <Pricing />;

      default:
        return <OrdersList />;
    }
  }, [currentPage]);

  const showFab = useMemo(() => {
    return (
      currentPage !== AppPage.SubmitAd &&
      currentPage !== AppPage.AdTimeSelect &&
      currentPage !== AppPage.Invoicing &&
      currentPage !== AppPage.AuthRequestDetail &&
      currentPage !== AppPage.Tutorial
    );
  }, [currentPage]);

  if (currentPage === undefined) return;
  return (
    <div className={styles.appWrapper}>
      {getPage}
      {showFab && <FestivalFab />}
    </div>
  );
};

export default AppPageWrapper;
